import { c as _c } from "react/compiler-runtime";
import { APIList } from '../../../../../../../typings/API.interface';
import { EventAttempt } from '../../../../../../../typings/EventAttempt.interface';
import { numberWithCommas } from '../../../../utils';
import { ATTEMPT_TRIGGER_LABELS } from '../../../../utils/attempt';
import Text from '../../../common/base/Text';
import DisplayDate from '../../../common/DisplayDate';
import { Status } from '../../../common/Status';
import Table from '../../../common/Table/Table';
import useFiltersOffset from '../../../hooks/useFiltersOffset';
export const EventAttempts = t0 => {
  const $ = _c(9);
  const {
    attempts,
    selected_attempt_id,
    onAttemptSelected
  } = t0;
  const {
    top_offset
  } = useFiltersOffset(78);
  let t1;
  if ($[0] !== attempts?.models || $[1] !== selected_attempt_id) {
    t1 = attempts?.models.map((attempt, i) => ({
      id: attempt.id,
      selected: attempt.id === selected_attempt_id,
      fields: [<Text key={`${attempt.id}-attempt`} size="s" muted={true} mono={true}>Attempt {attempts?.models.length - i}</Text>, <DisplayDate key={`${attempt.id}-date`} date={attempt.created_at} show_timezone={false} size="xs" />, <Status key={`${attempt.id}-status`} {...attempt} />, <Text key={`${attempt.id}-trigger`} size="xs" muted={true} mono={true}>{ATTEMPT_TRIGGER_LABELS[attempt.trigger]}</Text>, <Text key={`${attempt.id}-delivery`} size="xs" muted={true} mono={true}>{!attempt.delivery_latency ? "-" : `${numberWithCommas(attempt.delivery_latency)}ms`}</Text>, <Text key={`${attempt.id}-response`} size="xs" muted={true} mono={true}>{!attempt.response_latency ? "-" : `${numberWithCommas(attempt.response_latency)}ms`}</Text>]
    })) ?? [];
    $[0] = attempts?.models;
    $[1] = selected_attempt_id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rows = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["Attempt", "Attempt Date", "Status", "Attempt Trigger", "Delivery Latency", "Response Latency"];
    t3 = [{
      min: 140,
      max: 140
    }, {
      min: 150,
      max: 150
    }, {
      min: 140,
      max: 140
    }, {
      min: 100
    }, {
      min: 128,
      max: 128
    }, {
      min: 172,
      max: 172
    }];
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onAttemptSelected || $[6] !== rows || $[7] !== top_offset) {
    t4 = <Table headers={t2} widths={t3} onRowSelected={onAttemptSelected} fill={true} top_offset={top_offset} rows={rows} />;
    $[5] = onAttemptSelected;
    $[6] = rows;
    $[7] = top_offset;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};